function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.scrollX || document.documentElement.scrollLeft,
        scrollTop = window.scrollY || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let menuPosition = offset(document.querySelector('#js-NavMain'));

if(window.innerWidth > 960){
    window.addEventListener('scroll', function() {
        if(window.scrollY > menuPosition.top + 160){
            document.getElementById('header').classList.add('header--fixed');
        }
        else{
            document.getElementById('header').classList.remove('header--fixed');
        }
    })
}
